module.exports = __webpack_public_path__ + "img/1.dc2e4582.jpeg";